export default "__VITE_ASSET__931854e4__"